module.exports = __webpack_public_path__ + "img/Picture4.abdea73f.png";